import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "zxCourseNotice/";

// 课程公告 - 列表查询-分页
export const courseNoticePage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };
// 课程公告 - 标记通知已读
export const courseNoticeMarkRead = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "markRead", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
// 课程公告 - 全部标记已读
export const courseNoticeBatchMarkRead = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "batchMarkRead", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
// 课程公告 - 获取未读消息总数
export const courseNoticeUnRead = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "unreadNum", {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };
// 课程公告 - 获取最新的一条通知信息
export const courseNoticelast = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "last", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/courseNotice.js